// @flow

import styled, { css } from 'styled-components';

const styles = css`
  background-color: ${props => props.theme.input.bg};
  border: 1px solid ${props => props.theme.input.border};
  border-radius: ${props => props.theme.input.borderRadius};
  box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.075);
  color: ${props => props.theme.input.color};
  padding: 1em 1.2em;
  width: 100%;
  ::placeholder {
    color: ${props => props.theme.input.placeholder};
  }
`;

const Input = styled.input.attrs({
  type: props => props.type || 'text'
})`${styles}`;

const Select = styled.select`
  ${styles}
  padding: initial;
  font-size: 16px;
  max-width: 100%;
  width: initial;
`;

const Text = styled.textarea`${styles}`;

export {
  Input,
  Select,
  Text
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js